// Test IDs — one authoritative export used across the app.
export const HOME = {
  emergentLink: "emergent-link",
};

export const TID = {
  // Header
  headerLogo: "header-logo",
  navHome: "nav-home",
  navPhilosophy: "nav-philosophy",
  navPillars: "nav-pillars",
  navConnectivity: "nav-connectivity",
  navProof: "nav-proof",
  navEvent: "nav-event",
  navBlog: "nav-blog",
  navFaq: "nav-faq",
  navContact: "nav-contact",
  navBookVisit: "nav-book-visit",
  navStrategy: "nav-strategy-call",
  mobileMenuBtn: "mobile-menu-btn",
  mobileMenu: "mobile-menu",

  // Sticky
  stickyStrategy: "sticky-strategy-call",
  stickyWhatsapp: "sticky-whatsapp",
  stickyBrochure: "sticky-brochure",
  stickyBrochureOpen: "sticky-brochure-open",
  brochureModal: "brochure-modal",
  brochureModalClose: "brochure-modal-close",

  // Quick lead form (used in popups + brochure modal)
  quickLeadName: "quick-lead-name",
  quickLeadMobile: "quick-lead-mobile",
  quickLeadEmail: "quick-lead-email",
  quickLeadCity: "quick-lead-city",
  quickLeadLookingFor: "quick-lead-looking-for",
  quickLeadProfile: "quick-lead-profile",
  quickLeadConsent: "quick-lead-consent",
  quickLeadSubmit: "quick-lead-submit",

  // Footer contact panel
  footerContactName: "footer-contact-name",
  footerContactMobile: "footer-contact-mobile",
  footerContactEmail: "footer-contact-email",
  footerContactMessage: "footer-contact-message",
  footerContactConsent: "footer-contact-consent",
  footerContactSubmit: "footer-contact-submit",

  // Chatbot
  mascotLauncher: "mascot-launcher",
  mascotClose: "mascot-close",
  mascotInput: "mascot-input",
  mascotSend: "mascot-send",
  mascotMessages: "mascot-messages",

  // Popups
  scrollPopup: "scroll-popup",
  scrollPopupClose: "scroll-popup-close",
  exitPopup: "exit-popup",
  exitPopupClose: "exit-popup-close",

  // Hero / Home
  heroBookVisit: "cta-book-visit",
  heroStrategy: "cta-strategy-call",
  heroDownloadBrochure: "cta-download-brochure",
  heroRegister: "cta-register-hero",

  // Strategy call form (legacy testids retained for back-compat)
  strategyName: "strategy-name",
  strategyMobile: "strategy-mobile",
  strategyEmail: "strategy-email",
  strategyCity: "strategy-city",
  strategySlot: "strategy-slot",
  strategyStage: "strategy-stage",
  strategyNotes: "strategy-notes",
  strategyConsent: "strategy-consent",
  strategySubmit: "strategy-submit",

  // Consultation form (Google Calendar-integrated)
  consultName: "consultation-name",
  consultMobile: "consultation-mobile",
  consultEmail: "consultation-email",
  consultCity: "consultation-city",
  consultDateTime: "consultation-datetime",
  consultTopic: "consultation-topic",
  consultNotes: "consultation-notes",
  consultConsent: "consultation-consent",
  consultSubmit: "consultation-submit",
  consultGcalBtn: "consultation-gcal-btn",

  // Boarding pass + Spin wheel
  boardingPass: "boarding-pass",
  boardingTicketNo: "boarding-ticket-no",
  boardingDownload: "boarding-download",
  boardingShareWhatsapp: "boarding-share-whatsapp",
  boardingCopyLink: "boarding-copy-link",
  spinWheel: "spin-wheel",
  spinWheelBtn: "spin-wheel-btn",
  spinWheelResult: "spin-wheel-result",

  // Registrations ticker
  registrationsTicker: "registrations-ticker",
  registrationsRemaining: "registrations-remaining",

  // Contact form
  contactName: "contact-name",
  contactMobile: "contact-mobile",
  contactEmail: "contact-email",
  contactCity: "contact-city",
  contactProfile: "contact-profile",
  contactConsent: "contact-consent",
  contactSubmit: "contact-submit",

  // Event form
  eventStep1: "event-step-1",
  eventStep2: "event-step-2",
  eventStep3: "event-step-3",
  eventNext: "event-next",
  eventPrev: "event-prev",
  eventSubmit: "event-submit",
  eventScoreBanner: "event-score-banner",
  eventName: "event-name",
  eventMobile: "event-mobile",
  eventEmail: "event-email",
  eventCity: "event-city",
  eventAgeBracket: "event-age-bracket",
  eventOccupation: "event-occupation",
  eventCompany: "event-company",
  eventDesignation: "event-designation",
  eventBusinessFunction: "event-business-function",
  eventPurpose: "event-purpose",
  eventSearchDuration: "event-search-duration",
  eventFinancing: "event-financing",
  eventVisitConfirmation: "event-visit-confirmation",
  eventExploredSimilar: "event-explored-similar",
  eventDecisionInvolvement: "event-decision-involvement",
  eventWhatMatters: "event-what-matters",
  eventHomeUser: "event-home-user",
  eventReferredBy: "event-referred-by",
  eventSalesPersonName: "event-sales-person-name",
  eventConsent: "event-consent",

  // Pillar CTA
  pillarInlineStrategy: "pillar-inline-strategy",
  pillarInlineContact: "pillar-inline-contact", // legacy

  // CP portal
  cpPassword: "cp-password",
  cpLoginSubmit: "cp-login-submit",
  cpLogout: "cp-logout",
  cpDashboard: "cp-dashboard",
  cpTabOverview: "cp-tab-overview",
  cpTabContact: "cp-tab-contact-leads",
  cpTabEvent: "cp-tab-event-registrations",
  cpTabChat: "cp-tab-chat-leads",
  cpTabConsultations: "cp-tab-consultations",
  cpTabStrategy: "cp-tab-strategy-calls",
  cpTabSettings: "cp-tab-settings",
  cpTabAnalytics: "cp-tab-analytics",
  cpAnalyticsRegenerate: "cp-analytics-regenerate",
  cpAnalyticsRange: "cp-analytics-range",
  cpAnalyticsExport: "cp-analytics-export",
  cpTabConsultants: "cp-tab-consultants",
  cpConsultantAdd: "cp-consultant-add",
  cpConsultantUpload: "cp-consultant-upload",
  cpConsultantSave: "cp-consultant-save",
  cpConsultantDelete: "cp-consultant-delete",
  cpConsultantSearch: "cp-consultant-search",
  cpExportContact: "cp-export-contact",
  cpExportEvent: "cp-export-event",
  cpExportChat: "cp-export-chat",
  cpExportConsult: "cp-export-consult",
  cpExportStrategy: "cp-export-strategy",
  cpSettingsSave: "cp-settings-save",
  cpSettingsTestCrm: "cp-settings-test-crm",
  cpSettingsCrmUrl: "cp-settings-crm-url",
  cpSettingsCrmKey: "cp-settings-crm-key",
  cpSettingsCrmEnabled: "cp-settings-crm-enabled",
  cpSettingsWaProvider: "cp-settings-wa-provider",
  cpSettingsWaPhoneId: "cp-settings-wa-phone-id",
  cpSettingsWaToken: "cp-settings-wa-token",
  cpSettingsWaEnabled: "cp-settings-wa-enabled",
  cpSettingsWipe: "cp-settings-wipe",
  cpSettingsWipeConfirm: "cp-settings-wipe-confirm",
  cpSettingsWipeCancel: "cp-settings-wipe-cancel",
  cpSettingsWipeInput: "cp-settings-wipe-input",
  // Registration detail slide-over
  regDetailOverlay: "reg-detail-overlay",
  regDetailPanel: "reg-detail-panel",
  regDetailClose: "reg-detail-close",
  regDetailPass: "reg-detail-pass",
  regDetailViewBtn: "reg-detail-view-btn",

  // Blog
  blogCard: "blog-card",
  blogList: "blog-list",
  blogDetail: "blog-detail",

  // Footer
  footerRera: "footer-rera",
  footerCpPortal: "footer-cp-portal",
  footerWhatsapp: "footer-whatsapp",
  footerEmail: "footer-email",
};

export const PHONE = "+918446448123";
export const PHONE_DISPLAY = "844 644 8123";
export const WHATSAPP_URL = "https://wa.me/918446448123";
export const SALES_EMAIL = "sales@palihillcity.com";
export const RERA_NUMBER = "PP1270002601016";
export const EVENT_DATE_ISO = "2026-09-12T09:00:00+05:30";

// Reference photography kit uploaded by client — piped through wsrv.nl to
// convert 2.2 MB PNGs into ~200-400 KB WebP on-the-fly so hero + parallax
// backgrounds load quickly on preview hosts.
const _RAW_ASSETS = {
  heroSarasgad: "customer-assets.emergentagent.com/job_pali-hill-new/artifacts/3wclv5hn_Sarasgad_Golden_hour_sunset.png",
  entrance: "customer-assets.emergentagent.com/job_pali-hill-new/artifacts/kqalx21t_phc_entrance.png",
  cSector: "customer-assets.emergentagent.com/job_pali-hill-new/artifacts/5tfyyrkd_phc_c-sector.png",
  conceptVilla: "customer-assets.emergentagent.com/job_pali-hill-new/artifacts/ud272c3c_phc_concept%20villa.png",
};

const _proxy = (src, w = 1920, q = 78) =>
  `https://wsrv.nl/?url=${src}&w=${w}&output=webp&q=${q}`;

export const ASSET = {
  heroSarasgad: _proxy(_RAW_ASSETS.heroSarasgad, 1920, 80),
  heroSarasgadSm: _proxy(_RAW_ASSETS.heroSarasgad, 900, 70),
  entrance: _proxy(_RAW_ASSETS.entrance, 1600, 78),
  cSector: _proxy(_RAW_ASSETS.cSector, 1600, 78),
  conceptVilla: _proxy(_RAW_ASSETS.conceptVilla, 1200, 78),
  // Original PNGs kept for onError fallback if the proxy is briefly unavailable
  heroSarasgadOrig: `https://${_RAW_ASSETS.heroSarasgad}`,
  entranceOrig: `https://${_RAW_ASSETS.entrance}`,
  cSectorOrig: `https://${_RAW_ASSETS.cSector}`,
  conceptVillaOrig: `https://${_RAW_ASSETS.conceptVilla}`,
};

// Escape with Wealth strategy session config (legacy label — kept for internal reference)
export const STRATEGY = {
  framework: "Escape with Wealth",
  buyersHelped: 500,
  duration: "30 minutes",
  format: "Online video call",
  ctaLabel: "Book Online Consultation",
  ctaShort: "Free Consultation",
  headline: "Free online consultation with our sales team",
  subline: "A 30-minute Google Meet with a senior advisor — added straight to your Google Calendar.",
};

// Developer / promoter — Malpani Infra (from palihills.com)
export const DEVELOPER = {
  name: "Malpani Infra",
  tagline: "40 years of legacy · 35M+ sq. ft. in motion",
  legacyYears: 40,
  sqftInMotion: "35M+",
  intro:
    "Malpani Infra has spent four decades quietly delivering premium yet cost-effective residential and mixed-use projects across Maharashtra. Over 35 million sq. ft. acquired, developed, and continuously evolving — a portfolio built on customer aspirations, not marketing cycles.",
  values: [
    "Consistent delivery track record across four decades",
    "Land acquisition and clean-title expertise",
    "Customer-first, low-noise sales philosophy",
    "Deep local roots across the Konkan and Sahyadri belt",
  ],
};

// AQI comparison (source: palihills.com — AQI.IN / Weather Bug)
export const AQI_INDEX = [
  { place: "Pali Hills", value: 54, tone: "best" },
  { place: "Khopoli", value: 102 },
  { place: "Bandra", value: 128 },
  { place: "Borivali", value: 129 },
  { place: "Andheri", value: 130 },
  { place: "Worli", value: 133 },
  { place: "Mumbai (avg)", value: 133 },
  { place: "Navi Mumbai", value: 136 },
  { place: "Pune", value: 146 },
];

// Amenities with representative stock imagery (Unsplash CDN)
export const AMENITIES = [
  {
    label: "Members-only Gymkhana",
    detail: "An old-English style club with a full-size cricket ground at its centre.",
    image: "https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=1200&q=85&auto=format&fit=crop",
  },
  {
    label: "Tennis · Squash · Pickleball",
    detail: "Professional courts across three racket disciplines, lit for evening play.",
    image: "https://images.unsplash.com/photo-1622279457486-62dcc4a431d6?w=1200&q=85&auto=format&fit=crop",
  },
  {
    label: "Swimming Pool & Sun Deck",
    detail: "An outdoor pool with cabanas, timber decking, and a shallow kids' pool.",
    image: "https://images.unsplash.com/photo-1518495973542-4542c06a5843?w=1200&q=85&auto=format&fit=crop",
  },
  {
    label: "Yoga & Wellness Pavilion",
    detail: "An open-air deck for sunrise yoga, meditation, and quiet mornings.",
    image: "https://images.unsplash.com/photo-1545389336-cf090694435e?w=1200&q=85&auto=format&fit=crop",
  },
  {
    label: "Walking & Cycling Trails",
    detail: "Kilometres of shaded, contour-following trails through the private forest.",
    image: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1200&q=85&auto=format&fit=crop",
  },
  {
    label: "Party Lawn & Banquet Hall",
    detail: "A sunset-facing lawn and an all-weather banquet hall for family gatherings.",
    image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&q=85&auto=format&fit=crop",
  },
  {
    label: "Kids' Play Area & Siesta Room",
    detail: "A safely-fenced play zone with soft flooring plus a shaded siesta room.",
    image: "https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=1200&q=85&auto=format&fit=crop",
  },
  {
    label: "Lake & Camping Grounds",
    detail: "A stocked lake for kayaking and a designated overnight camping zone.",
    image: "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=1200&q=85&auto=format&fit=crop",
  },
];

// Connectivity tiles used on the Home mini strip
export const HOME_CONNECTIVITY_TILES = [
  { label: "From Mumbai", value: "2 hours" },
  { label: "From Pune", value: "2 hours" },
  { label: "From Mumbai-Pune Expressway", value: "40 mins" },
  { label: "From Goa Highway (NH-66)", value: "15 mins" },
];

// Consultation form config — direct online session with sales team (Google Cal)
export const CONSULTATION = {
  title: "Book an Online Consultation",
  subtitle: "30-minute Google Meet with our senior sales advisor",
  duration: 30,
  cta: "Book my consultation",
  ctaShort: "Free Consultation",
  benefits: [
    "Live walkthrough of the Chapter III plot layout",
    "Clarity on pricing, payment plan and RERA/NA paperwork",
    "Connectivity map: Mumbai 3.0, the Missing Link and Navi Mumbai International Airport",
    "Straight to your Google Calendar — no back-and-forth",
  ],
};

export const CONSULTATION_TOPICS = [
  "Chapter III project overview",
  "Pricing & payment plan",
  "Plot selection guidance",
  "Legal, RERA & paperwork walk-through",
  "Investment / SIP outlook",
  "General questions",
];

// Prize Wheel — Chapter III launch rewards (updated Jul 2026).
//
// Six prize categories with weighted counts summing to a 53-slot wheel. The
// authoritative layout lives on the backend (`GET /api/event/wheel-layout`)
// and the client mirrors it 1:1 so `prize_index` from the spin endpoint
// aligns with the correct visual slice.
export const PRIZE_TYPES = [
  { id: "konkan-hamper", label: "Konkan Gift Hamper",
    detail: "A locally-curated hamper — cashew, kokum syrup, jaggery, spices from the Konkan belt.",
    color: "#0B4A3D", count: 26 },
  { id: "villa-consult", label: "Free Villa Design Consultation",
    detail: "A 45-minute one-on-one with our in-house architect to sketch out the villa on your plot.",
    color: "#00A676", count: 16 },
  { id: "weekend-stay", label: "Exclusive Weekend Stay Package",
    detail: "A complimentary two-night stay for two at a partner Konkan property.",
    color: "#A6CE39", count: 5 },
  { id: "airpods", label: "Apple AirPods",
    detail: "A pair of Apple AirPods, on the house.",
    color: "#C9B37D", count: 3 },
  { id: "discount-50k", label: "₹50,000 Extra Discount Voucher",
    detail: "An additional ₹50,000 off, on top of the Chapter III launch pricing — applied at plot booking.",
    color: "#B94A2E", count: 2 },
  { id: "iphone-17", label: "iPhone 17 Voucher",
    detail: "The grand prize — an iPhone 17 voucher, redeemable after your plot booking.",
    color: "#1F3A2E", count: 1 },
];

// Smoothed Weighted Round-Robin (SWRR) placement — mirrors the backend
// `_build_wheel_slices` implementation. At each slot every type's credit
// grows by its count; the highest-credit type wins and loses `total`
// credit. Produces mathematically-optimal even spreading of every category
// around the whole circle, integer-only so FE+BE outputs stay identical.
function buildWheelSlices(types) {
  const total = types.reduce((s, t) => s + t.count, 0);
  const credits = Object.fromEntries(types.map((t) => [t.id, 0]));
  const slices = [];
  for (let s = 0; s < total; s++) {
    // Grow all credits
    for (const t of types) credits[t.id] += t.count;
    // Pick highest credit — deterministic tiebreak on catalog order
    let bestIdx = 0;
    let bestCredit = credits[types[0].id];
    for (let i = 1; i < types.length; i++) {
      const c = credits[types[i].id];
      if (c > bestCredit) { bestCredit = c; bestIdx = i; }
    }
    const winner = types[bestIdx];
    credits[winner.id] -= total;
    slices.push({
      id: winner.id, label: winner.label, detail: winner.detail, color: winner.color,
    });
  }
  return slices;
}

export const PRIZE_WHEEL = buildWheelSlices(PRIZE_TYPES);

// Terms shown alongside the wheel (both the interactive one and the Step-1
// preview). Kept intentionally short — the launch-visit + plot-booking
// condition is the only rule customers need to see.
export const WHEEL_TERMS =
  "All gifts are applicable only if the customer visits the Chapter III launch event on Sept 12–13, 2026 and books a plot.";

export const STRATEGY_TIME_SLOTS = [
  "This weekend",
  "Next weekend",
  "Weekday evening (6-9 PM)",
  "Weekend morning (9-12 PM)",
  "Weekend afternoon (2-5 PM)",
  "Any convenient time — you suggest",
];

export const STRATEGY_STAGES = [
  "Just exploring — want to understand the framework",
  "Actively evaluating 2-3 projects",
  "Ready to decide in the next 30 days",
  "Buying for family / retirement",
  "Investment / land SIP outlook",
];

export const NAV_LINKS = [
  { label: "Five Pillars", to: "/pillars/nature", testid: TID.navPillars },
  { label: "Connectivity", to: "/connectivity", testid: TID.navConnectivity },
  { label: "Proof of Peace", to: "/proof-of-peace", testid: TID.navProof },
  { label: "Chapter III", to: "/event", testid: TID.navEvent },
  { label: "Journal", to: "/blog", testid: TID.navBlog },
  { label: "FAQ", to: "/faq", testid: TID.navFaq },
];

export const PILLARS = [
  {
    slug: "nature",
    label: "Peace with Nature",
    tagline: "Waking with the birds, not the meeting.",
    color: "#0B4A3D",
    image:
      "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=1600&q=85&auto=format&fit=crop",
    intro:
      "A 300-acre private hill near Pali — hills, waterfalls, forest, valley streams. Golden hour is the site visit. Everything else is optional.",
    long: [
      "Chapter III is not a plot on a highway. It is a plot on a hill — a 300-acre private ridge above the clouds, threaded with river streams and pocket forests, half an hour from the Ashtavinayak temple and two hours from the front door of most Mumbai and Pune homes.",
      "The land was drawn around the terrain, not the other way around. Roads follow the contours. Pocket gardens replace concrete plazas. Wide, quiet lots hold most of the trees that were already there.",
      "You will hear birds first, and then, much later, the neighbour's car.",
    ],
    stats: [
      { label: "Private Hill", value: "300 acres" },
      { label: "Layout", value: "26+ acres" },
      { label: "Elevation", value: "Above the clouds" },
    ],
  },
  {
    slug: "wealth",
    label: "Peace with Wealth",
    tagline: "The quiet compounding of land.",
    color: "#0B4A3D",
    image:
      "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=1600&q=85&auto=format&fit=crop",
    intro:
      "Land near the Navi Mumbai International Airport and Mumbai 3.0 corridor is not a get-rich story. It is a get-rich-slowly story — which is exactly why it works.",
    long: [
      "The Missing Link on the Mumbai-Pune Expressway is under construction. The new international airport at Navi Mumbai is under construction. The state-notified area around it is under construction. The Konkan corridor is being rewritten around Pali.",
      "None of that is a return, and no honest brochure will promise you one. What it is, is exposure — a slow, boring compounding exposure to a corridor that is being physically rebuilt around a second economic gravity centre.",
      "Buy the land if you would like the calm of holding it. The rest will do what it does.",
    ],
    stats: [
      { label: "To N. Mumbai Airport", value: "1.5 hrs" },
      { label: "To Expressway", value: "45 mins" },
      { label: "Phases sold", value: "I & II" },
    ],
  },
  {
    slug: "mind",
    label: "Peace of Mind",
    tagline: "Clear title. Clear paperwork. Clear conscience.",
    color: "#0B4A3D",
    image:
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=85&auto=format&fit=crop",
    intro:
      "Non-Agricultural. RERA-registered. Sanad in place. A gated layout where every road, boundary, and service is drawn on paper before it is drawn on the hill.",
    long: [
      "The single biggest cost of a second home is not the plot. It is the ten years afterwards spent verifying the title, chasing conversion certificates, arguing over easements, and hoping the road access holds up.",
      "Chapter III skips all of that. NA conversion is complete. The 7/12 extract reflects it. The layout is RERA-registered under Maharashtra RERA. Underground electrical cabling and individual water connections are part of the plotted development, not future promises.",
      "Peace of mind is not sold as a feature. It is a floor.",
    ],
    stats: [
      { label: "Classification", value: "Non-Agricultural" },
      { label: "Registration", value: "MahaRERA" },
      { label: "Utilities", value: "Underground" },
    ],
  },
  {
    slug: "family",
    label: "Peace with Family",
    tagline: "The land that is still there for the next visit.",
    color: "#0B4A3D",
    image:
      "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1600&q=85&auto=format&fit=crop",
    intro:
      "A weekend home is really the site of the memories your family hasn't made yet. The best ones need trees, air, and a Sunday breakfast that runs long.",
    long: [
      "Every parent who has ever tried to prise a phone out of a teenager's hand at dinner knows that the ambient environment matters more than the rule. Chapter III is designed to make phones boring: dense foliage, waterfalls within walking distance, low light pollution at night, and enough open sky to see the constellations that Mumbai has forgotten.",
      "It is a place you can hand down. That is not marketing language — the plot is yours, in perpetuity, freely transferable, under a clear title.",
    ],
    stats: [
      { label: "From Mumbai", value: "2 hrs" },
      { label: "From Pune", value: "2 hrs" },
      { label: "Layout style", value: "Gated" },
    ],
  },
  {
    slug: "time",
    label: "Peace with Time",
    tagline: "The two-hour Sunday you didn't know you had.",
    color: "#0B4A3D",
    image:
      "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?w=1600&q=85&auto=format&fit=crop",
    intro:
      "Pali sits inside a two-hour arc from both Mumbai and Pune, 45 minutes from the Expressway, and 1.5 hours from the upcoming Navi Mumbai International Airport. Weekend homes work when the drive is a promise, not a punishment.",
    long: [
      "The Missing Link shortens the Mumbai-Pune Expressway by roughly 20 minutes and eliminates the ghat bottleneck. The Navi Mumbai International Airport opens a second front for anyone travelling in and out. The Ring Road connects the coastal spine to the inland corridor.",
      "The map redraws around Pali quietly. You will not notice, from the plot, that any of this is happening. That is the point.",
    ],
    stats: [
      { label: "Missing Link", value: "In progress" },
      { label: "To N. Mumbai Airport", value: "1.5 hrs" },
      { label: "Ashtavinayak", value: "20 mins" },
    ],
  },
];

export const FAQ_ITEMS = [
  {
    q: "What is the Chapter III launch price per sqft?",
    a: "Chapter III (Phase 3) launches on 12–13 September 2026 at ₹1,990 per sqft. Phase 1 launched in 2019 at ₹990/sqft and Phase 2 in 2021 at ₹1,490/sqft — both sold out. That's roughly 2× base price across seven years at layout level.",
  },
  {
    q: "How does Pali Hill City compare to House of Abhinandan Lodha (HoABL), Godrej, Lodha, Kalpataru, Hiranandani, or L&T Realty?",
    a: "HoABL is the closest direct competitor by asset class (plotted land). Pali Hill City differentiates on a documented sellout track record — Phase 1 and 2 sold out in 18 months, 110+ plots absorbed — and concrete handover state (roads and utilities delivered at handover, not paper layouts). Godrej Properties, Lodha Realty, Kalpataru, Hiranandani and L&T Realty operate primarily vertical residential in Mumbai metro — a different asset class, higher ticket size (₹1.5–4 Cr for a 2-BHK) with less construction control. See the full side-by-side at /vs.",
  },
  {
    q: "Is plotted land near Mumbai–Pune a good investment in 2026?",
    a: "The Mumbai–Pali corridor sits inside three simultaneous infrastructure catalysts: the Mumbai-Pune Expressway Missing Link, the Navi Mumbai International Airport (NMIA) opening in phases, and the MTHL/Coastal Road connectivity. Pali Hill City's own layout-level appreciation (₹990 → ₹1,490 → ₹1,990/sqft across 7 years) documents the trajectory investors have already realised at this specific address.",
  },
  {
    q: "What is Pali Hill City's MahaRERA registration number?",
    a: "MahaRERA registration number PP1270002601016. The registration is displayed in the site footer on every page, and the QR code linking to the MahaRERA portal is included in the brochure.",
  },
  {
    q: "Is Pali Hill City the same as Pali Hill in Bandra, Mumbai?",
    a: "No. Pali Hill City is a plotted-land project in Pali village, Sudhagad taluka, Raigad district — approximately 90 km inland from Mumbai. Pali Hill in Bandra is an unrelated residential neighbourhood inside Mumbai. The two share only the name.",
  },
  {
    q: "What is the difference between an NA plot and farmland?",
    a: "A Non-Agricultural (NA) plot has been formally converted from agricultural use by the district Collector's office. That conversion — a Sanad — is what lets you legally build a residence, connect utilities, and register the land as a residential parcel. Farmland remains under agricultural classification and carries state-level restrictions on construction and transfer. All Chapter III plots are NA.",
  },
  {
    q: "What are the payment plans?",
    a: "Payment plans are offered in structured tranches aligned with layout milestones. The Chapter III launch on Sept 12–13, 2026 introduces the current plan for both self-funded and financed buyers. Bank tie-ups are in place for buyers who require finance.",
  },
  {
    q: "When can I start building on my plot?",
    a: "Immediately after registration and possession. Because the layout is NA-converted with a clear title, individual construction can begin without waiting for a conversion process. Chapter III supplies underground electrical cabling, individual water connections, and gated internal roads at handover.",
  },
  {
    q: "How far is Pali from Mumbai, Pune, and the new airport?",
    a: "Approximately 2 hours from central Mumbai and Pune, 45 minutes from the Mumbai-Pune Expressway, and 1.5 hours from the upcoming Navi Mumbai International Airport.",
  },
  {
    q: "Are Phase 1 and Phase 2 still available?",
    a: "Phase 1 (2019, ₹990/sqft) and Phase 2 (2021, ₹1,490/sqft) are both sold out — together, 110+ plots absorbed inside an 18-month window. Chapter III is the third and final phase of the layout. Detailed plot inventory and pricing sheets are shared with buyers who register interest at the site office.",
  },
];

export const EVENT_EXPECTATIONS = [
  "Site visit booking",
  "Pricing & payment plan",
  "Meet the founders",
  "Legal/RERA clarity",
  "Comparing options",
];

export const PLOT_SIZES = [
  "Small (up to 2000 sqft)",
  "Mid (2000-4000 sqft)",
  "Large (4000+ sqft)",
  "Not sure yet",
];

export const CONNECTIVITY_ITEMS = [
  {
    title: "Mumbai-Pune Expressway — Missing Link",
    time: "Under construction · shortens journey by ~20 min",
    body:
      "The 13.3 km Missing Link bypasses the Khandala ghat bottleneck with tunnels and cable-stayed bridges. Once open, Pali is within a genuine 90-minute door-to-door drive from parts of Mumbai.",
    tag: "Corridor",
  },
  {
    title: "Navi Mumbai International Airport",
    time: "Opening in phases · 1.5 hrs from Pali",
    body:
      "A second international gateway for Mumbai, engineered to move the aviation load away from a saturated single-airport city. The Navi Mumbai International Airport reshapes the demand map for the entire eastern Konkan corridor.",
    tag: "Airport",
  },
  {
    title: "Mumbai 3.0 & the Navi Mumbai Notified Area",
    time: "State-notified · long horizon",
    body:
      "A deliberate state-level rewriting of the metropolitan region around the Navi Mumbai International Airport catchment. Pali sits inside the quiet inland edge of this notified area — close enough for accessibility, far enough for calm.",
    tag: "Policy",
  },
  {
    title: "Ashtavinayak Temple, Pali",
    time: "20 minutes from Chapter III",
    body:
      "One of the eight Ashtavinayak temples of Maharashtra. The cultural anchor for the region — the reason Pali has always been a destination, long before it was a corridor.",
    tag: "Culture",
  },
  {
    title: "Coastal & Trans-Harbour Links",
    time: "Complementary infrastructure",
    body:
      "The Coastal Road and the Mumbai Trans-Harbour Link redraw how South Bombay reaches Navi Mumbai. Together with the Missing Link, the whole corridor becomes reachable rather than aspirational.",
    tag: "Corridor",
  },
];

export const APPRECIATION_INDEX = [
  { year: 2019, value: 100 },
  { year: 2020, value: 118 },
  { year: 2021, value: 142 },
  { year: 2022, value: 173 },
  { year: 2023, value: 208 },
  { year: 2024, value: 246 },
  { year: 2025, value: 289 },
  { year: 2026, value: 328 },
];

export const TESTIMONIALS = [
  {
    quote:
      "Feels like a mini Mahabaleshwar and it is so close to Mumbai. Nature, waterfalls, mountains all around. The price point is great for the investment value, and the EMI plan made it easy. I finalised my plot on the very first visit.",
    name: "Mr. Nadar",
    role: "Plot Owner · Pali Hill City",
    rating: 5,
    when: "Verified on Google",
  },
  {
    quote:
      "Very good project for living. Roads are well connected and the layout is clean. Site is close to the Expressway which is a big advantage for weekend trips from Mumbai.",
    name: "Mukesh Pal",
    role: "Verified Owner · Malpani Pali Hill City (2+ yrs)",
    rating: 5,
    when: "Verified on Google",
  },
  {
    quote:
      "Recently invested at a Pali layout through the team and it was a good experience. Thorough professional approach with a lot of market insights which helps investors make correct decisions.",
    name: "Vikas Bhansali",
    role: "Plot Owner · Aurum Parks, Pali",
    rating: 5,
    when: "Verified on Google",
  },
];

// Direct Google Maps deep-link to the "Pali Hills - Developed N A Plots" listing.
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/maps/place/Pali+Hills+-+Developed+N+A+Plots/@18.5083327,73.2681808,8808m/data=!3m1!1e3!4m6!3m5!1s0x3be8174a827ae091:0x6b5db9069288a89c!8m2!3d18.5133366!4d73.2471228";

export const HERO_IMAGES = [
  "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?w=1920&q=85&auto=format&fit=crop",
  "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=1920&q=85&auto=format&fit=crop",
];
